import { Col, Container, Row } from "react-bootstrap"
import AllOffers from "../../Components/Offers/AllOffers"
import VendorSideBar from "../../Components/Vendor/VendorSideBar"

const VendorOfferPage = () => {
    return    (
        <Container >
        <Row className='py-3'>
            <Col sm="3" xs="2" md="2">
            <VendorSideBar/>
            </Col>
            <Col sm="9" xs="10" md="10">
            <AllOffers />

            </Col>
        </Row>
    </Container>
    )

}

export default VendorOfferPage